import React, { memo, useState } from "react";

import Button from "components/Button/index";
import Modal from "components/Models/index";

import "./UploadOptions.scss";
import CustomRadioButton from "components/CustomRadioButton/index";
import useScreenMobile from "hooks/useScreen";

function UploadOptions({ onCancelPress, onUploadPress, showUploadOptionsArr }) {
  const [checked, setChecked] = useState(0);

  const radioContent = ["Add Version", "Keep Both Files"];

  const handleRadio = (index) => {
    setChecked(index);
  };
  const isMobile = useScreenMobile({ size: 992 });

  const fileRender = () => {
    if (!showUploadOptionsArr || showUploadOptionsArr.length === 0) return "File(s)";
    
    const firstName = showUploadOptionsArr[0].name;
    const truncatedName = firstName.length > 50 ? firstName.substring(0, 50) + "..." : firstName;
    
    if (showUploadOptionsArr.length === 1) {
      return `"${truncatedName}"`;
    } else {
      return `"${truncatedName}" and ${showUploadOptionsArr.length - 1} other file${showUploadOptionsArr.length > 2 ? 's' : ''}`;
    }
  };

  const alreadyExistsMsg = showUploadOptionsArr?.length > 1 ? "already exist" : "already exists";
  const itemType = showUploadOptionsArr?.length > 1 ? "items" : "item";

  return (
    <>
      (
      <Modal isDisabled showFooter={false} showHeader={false} containerClass="upload-options-modal">
        <div className="UploadOptions">
          <div className="UploadOptionsWrapper">
            <h1>Upload Options</h1>
            {isMobile ? (
              <p>
                {fileRender()} {alreadyExistsMsg} in this location. Do you want to
                replace the existing {itemType} with a new version or keep both
                files.
              </p>
            ) : (
              <p>
                {fileRender()} {alreadyExistsMsg} in this location.
                <br />
                Do you want to replace the existing {itemType} with a<br />
                new version or keep both files.
              </p>
            )}
          </div>
          <div className="UploadOptionsMain">
            {radioContent.map((ele, index) => (
              <div key={index} className="radioButtonContainer">
                <CustomRadioButton
                  label={ele}
                  checked={checked === index}
                  value={checked}
                  handleOnchange={() => {
                    handleRadio(index);
                  }}
                />
              </div>
            ))}
          </div>
          <div className="UploadOptionsButtons">
            <Button
              type="white"
              title="Cancel"
              width={"35.6218%"}
              onClick={onCancelPress}
            />
            <Button
              type="violet"
              title="Upload"
              width={"29.6218%"}
              onClick={() => onUploadPress(checked)}
            />
          </div>
        </div>
      </Modal>
      )
    </>
  );
}

export default memo(UploadOptions);
